import {HEADER_OFFSET} from './header';

export default function () {

    const alert = document.querySelector('.alert');
    const header = document.querySelector('.js-header');
    const hamburger = document.querySelector('.js-hamburger');
    const nav = document.querySelector('.js-header__nav');
    const body = document.querySelector('body');
    if (hamburger) {
        hamburger.addEventListener('click', debounce((e) => {
            e.preventDefault();
            if (hamburger.classList.contains('active')) {
                body.classList.remove('nav-active');
                hamburger.classList.remove('active');

                window.setTimeout(function() {
                    hamburger.classList.remove('hamburger--back');
                }, 1300);
            } else {
                getPaddingTop();
                body.classList.add('nav-active');
                hamburger.classList.add('active');

                window.setTimeout(function() {
                    hamburger.classList.add('hamburger--back');
                }, 1300);
            }
            return false;
        }, 300));

        window.addEventListener('scroll', debounce(() => {
            getPaddingTop();
        }, 20));

        window.addEventListener('resize',() => {
            getPaddingTop();
        });
    }

    function getPaddingTop() {
        if (window.innerWidth <= 1024) {
            const scroll = window.scrollY;
            const headerHeight = Math.ceil(header.getBoundingClientRect().height);
            let topPos = headerHeight;
            if (alert && scroll < (headerHeight + HEADER_OFFSET)) {
                topPos += Math.ceil(alert.getBoundingClientRect().height);
            }
            nav.style.paddingTop = topPos + 'px';
            return topPos;
        } else {
            nav.style.paddingTop = null;
        }

    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

}
